import React from "react";
import Link from "next/link";
import { ChevronRight } from "react-feather";

interface BreadcrumbItem {
  label: string;
  link?: string;
  onclick?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <nav className="w-full   font-normal">
      <ol className="flex items-center text-base leading-[70px] text-[#4C4E52]">
        {items.map((item, index) => (
          <li key={index} className="flex items-center group">
            {index > 0 && (
              <ChevronRight
                className={`w-4 ml-1 mr-2 text-black group-hover:text-[#079ea6] group-hover:ml-2`}
              />
            )}
            {item.onclick ? (
              <button
                onClick={item.onclick}
                className={`${
                  index === items.length - 1
                    ? "font-bold text-[#037a6a]"
                    : "text-[#4C4E52] group-hover:text-[#079ea6]"
                }`}
              >
                {item.label}
              </button>
            ) : item.link ? (
              <Link
                href={item.link}
                className={`${
                  index === items.length - 1
                    ? " text-[#037a6a]"
                    : "text-[#4C4E52] group-hover:text-[#079ea6]"
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={`${
                  index === items.length - 1
                    ? "text-[#037a6a]"
                    : "text-[#4C4E52] group-hover:text-[#079ea6]"
                }`}
              >
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
